import React, { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SettingsSVG from '../../svgs/SettingsSVG';
import NewRequestSVG from '../../svgs/NewRequestSVG';
import TablesSVG from '../../svgs/TablesSVG';
import ProfileSVG from '../../svgs/ProfileSVG';
import CalendarSVG from '../../svgs/CalendarSVG';
import DashboardSVG from '../../svgs/DashboardSVG';
import CustomNavLink from './CustomNavLink';

const ApproverSidebarMenu: React.FC = () => {
    const location = useLocation();
    const { pathname } = location;

    return (
        <>
                <nav className="mt-5 py-4 px-4 lg:mt-9 lg:px-6">
                    
                    <div>
                    <h3 className="mb-4 ml-4 text-sm font-semibold text-bodydark2">
                        MENU
                    </h3>

                    <ul className="mb-6 flex flex-col gap-1.5">
                
                        <li>
                        <CustomNavLink navPath="/" navPathInclude="/" isAbsoluteDashboard={true}>
                            <DashboardSVG />
                            Dashboard
                        </CustomNavLink>
                        </li>
                        <li>
                        <CustomNavLink navPath="/request" navPathInclude="/request" isAbsoluteDashboard={false}>
                            <NewRequestSVG />
                            My Request List
                        </CustomNavLink>
                        </li>                         
                        <li>
                        <CustomNavLink navPath="/settings" navPathInclude="settings" isAbsoluteDashboard={false}>
                        <SettingsSVG />
                            Settings
                        </CustomNavLink>                            
                        </li>            
                    </ul>

                    </div>

                </nav>  
        </>          
    );
};

export default ApproverSidebarMenu;